export default "https://cdn.retino.com/dist/files/react/img/shipping/logo_geis.png";